import React from 'react';
import Icon from '../../../components/AppIcon';

const VehicleTypeSelector = ({ selectedType, onTypeChange }) => {
  const vehicleTypes = [
    {
      id: 'ev',
      name: 'Elektrisk',
      icon: 'Zap',
      discount: '50%',
      description: 'Fullelektrisk kjøretøy',
      color: 'var(--color-success)'
    },
    {
      id: 'hybrid',
      name: 'Hybrid',
      icon: 'Battery',
      discount: '25%',
      description: 'Plugin-hybrid kjøretøy',
      color: 'var(--color-primary)'
    },
    {
      id: 'diesel',
      name: 'Diesel',
      icon: 'Fuel',
      discount: '0%',
      description: 'Konvensjonelt kjøretøy',
      color: 'var(--color-muted-foreground)'
    },
    {
      id: 'petrol',
      name: 'Bensin',
      icon: 'Droplet',
      discount: '0%',
      description: 'Konvensjonelt kjøretøy',
      color: 'var(--color-muted-foreground)'
    }
  ];

  return (
    <div className="w-full">
      <h3 className="text-base md:text-lg font-semibold mb-4 md:mb-6 text-foreground font-heading">
        Velg kjøretøytype
      </h3>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
        {vehicleTypes?.map((type) => (
          <button
            key={type?.id}
            onClick={() => onTypeChange(type?.id)}
            className={`relative p-4 md:p-6 transition-all ${
              selectedType === type?.id
                ? 'bg-surface-elevated border-2 border-primary' :'bg-card border-2 border-border hover:border-muted-foreground'
            }`}
            style={{ borderRadius: 'var(--radius-sm)' }}
            aria-label={`Select ${type?.name} vehicle type`}
            aria-pressed={selectedType === type?.id}
          >
            <div className="flex flex-col items-center gap-3 md:gap-4">
              <div
                className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center transition-all"
                style={{
                  background: selectedType === type?.id ? `${type?.color}15` : 'transparent'
                }}
              >
                <Icon
                  name={type?.icon}
                  size={window.innerWidth >= 768 ? 32 : 24}
                  color={selectedType === type?.id ? type?.color : 'var(--color-muted-foreground)'}
                  strokeWidth={2}
                />
              </div>
              <div className="text-center">
                <div className={`text-sm md:text-base font-medium mb-1 ${
                  selectedType === type?.id ? 'text-foreground' : 'text-muted-foreground'
                }`}>
                  {type?.name}
                </div>
                <div className="text-xs md:text-sm text-muted-foreground font-caption">
                  {type?.description}
                </div>
              </div>
              {type?.discount !== '0%' && (
                <div
                  className="absolute top-2 right-2 px-2 py-1 text-xs font-medium"
                  style={{
                    background: `${type?.color}15`,
                    color: type?.color,
                    borderRadius: 'var(--radius-sm)'
                  }}
                >
                  -{type?.discount}
                </div>
              )}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default VehicleTypeSelector;